import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.fromTo(
  ".card-folder",
  {
    opacity: 0,
    filter: "blur(6px)",
  },
  {
    opacity: 1,
    filter: "blur(0px)",
    duration: 0.9,
    ease: "power3.out",
    stagger: {
      each: 0.25,
      from: "start",
    },
    scrollTrigger: {
      trigger: ".needs-section__list",
      start: "top 80%",
      once: true,
    },
    clearProps: "filter",
  }
);


gsap.fromTo(
  ".prestations-list-section",
  {
    opacity: 0,
  },
  {
    opacity: 1,
    duration: 0.9,
    ease: "back.out(2)", // rebond élégant
    stagger: 0.12,
    scrollTrigger: {
      trigger: ".prestations-list-section",
      start: "top 80%",
      once: true,
    },
  }
);

gsap.fromTo(
  ".key-numbers-section",
  {
    y: 60,
    opacity: 0
  },
  {
    y: 0,
    opacity: 1,
    duration: 0.9,
    stagger: 0.12,
    scrollTrigger: {
      trigger: ".key-numbers-section",
      start: "top 80%",
      once: true,
    },
  }
);


gsap.fromTo(
  ".about-us-section__list li",
  {
    y: 60,
    opacity: 0,
    scale: 0.96,
  },
  {
    y: 0,
    opacity: 1,
    scale: 1,
    duration: 0.9,
    ease: "back.out(2)",
    stagger: 0.12,
    scrollTrigger: {
      trigger: ".about-us-section__content",
      start: "top 80%",
      once: true,
    },
  }
);

gsap.fromTo(
  ".about-us-section__content",
  {
    y: 60,
    opacity: 0,
    scale: 0.96,
  },
  {
    y: 0,
    opacity: 1,
    scale: 1,
    duration: 0.9,
    ease: "back.out(2)",
    stagger: 0.12,
    scrollTrigger: {
      trigger: ".about-us-section__content",
      start: "top 80%",
      once: true,
    },
  }
);

gsap.fromTo(
  ".page-header__container-text",
  {
    y: 24,
    opacity: 0,
    filter: "blur(8px)",
  },
  {
    y: 0,
    opacity: 1,
    filter: "blur(0px)",
    duration: 1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".page-header__container",
      start: "top 75%",
      once: true,
    },
  }
);

gsap.fromTo(
  ".page-header__container-illustration",
  {
    x: 32,
    opacity: 0,
    scale: 0.98,
  },
  {
    x: 0,
    opacity: 1,
    scale: 1,
    duration: 1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: ".page-header__container",
      start: "top 75%",
      once: true,
    },
  }
);

gsap.fromTo(
  ".latest-news",
  {
    y: 60,
    opacity: 0
  },
  {
    y: 0,
    opacity: 1,
    duration: 0.9,
    stagger: 0.12,
    scrollTrigger: {
      trigger: ".latest-news",
      start: "top 80%",
      once: true,
    },
  }
);

gsap.fromTo(
  ".testimonies-section",
  {
    y: 60,
    opacity: 0
  },
  {
    y: 0,
    opacity: 1,
    duration: 0.9,
    stagger: 0.12,
    scrollTrigger: {
      trigger: ".testimonies-section",
      start: "top 80%",
      once: true,
    },
  }
);

gsap.fromTo(
  ".references-section",
  {
    y: 60,
    opacity: 0
  },
  {
    y: 0,
    opacity: 1,
    duration: 0.9,
    stagger: 0.12,
    scrollTrigger: {
      trigger: ".references-section",
      start: "top 80%",
      once: true,
    },
  }
);